<script>
    import { onMount } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    import { AssetField } from '../methods/AssetField.js';
    import { getPublicUrl } from '../methods/getPublicUrl.js';
    import { isPlainObject } from '../methods/isPlainObject.js';
    import { isEmpty } from '../methods/isEmpty.js';

    export let mtappVars;
    export let id;
    export let storage;
    export let storageKey;
    export let handle;
    export let fieldBlock;
    let assetFieldInstance;
    if (!isPlainObject(storage[storageKey])) {
        storage[storageKey] = {
            id: '',
            url: '',
            thumbnail: '',
            alt: ''
        };
    }

    $: assetAddButtonLabel = fieldBlock.buttonLabel ? fieldBlock.buttonLabel : `${fieldBlock.label}を選択`;

    const dispatch = createEventDispatcher();
    function triggerInputChange() {
        dispatch('inputchange');
    }

    onMount(() => {
        assetFieldInstance = new AssetField(id, fieldBlock.type, handle);
        if (typeof fieldBlock.uploadDirectory === 'string') {
            window.mtappVars.__system.assetField.uploadDirectories[handle] = fieldBlock.uploadDirectory;
        } else if (Array.isArray(fieldBlock.uploadDirectory)) {
            window.mtappVars.__system.assetField.uploadDirectories[handle] = [...fieldBlock.uploadDirectory];
        }
    });

    /**
     * URL からファイル名を取得する
     *
     * @param {string} url
     */
    function getFilename(url) {
        return url ? new URL(url, url.startsWith('http') ? undefined : window.location.origin).pathname.split('/').pop() : '';
    }
    function select() {
        return assetFieldInstance.select();
    }

    function remove() {
        storage[storageKey].id = '';
        storage[storageKey].url = '';
        if (fieldBlock.type === 'image') {
            storage[storageKey].thumbnail = '';
        }
        triggerInputChange();
        return assetFieldInstance.remove();
    }
</script>

<div data-handle={handle}>
    <input
        id={id}
        class="form-control mtapp-mf-field-{fieldBlock.type}"
        type="hidden"
        bind:value={storage[storageKey].id}
        on:blur={triggerInputChange} />
    {#if fieldBlock.type === 'image'}
        <input
            id={id + '-thumb'}
            class="form-control mtapp-mf-field-thumbnail"
            type="hidden"
            bind:value={storage[storageKey].thumbnail}
            on:blur={triggerInputChange} />
    {/if}
    <input id={id + '-url'} class="form-control" type="hidden" bind:value={storage[storageKey].url} on:blur={triggerInputChange} />

    {#if storage[storageKey].url}
        <a href={getPublicUrl(storage[storageKey].url)} target="_blank" class="d-block pb-2">
            {#if fieldBlock.type === 'image' && storage[storageKey].thumbnail}
                <img src={getPublicUrl(storage[storageKey].thumbnail)} class="img-fluid" alt={fieldBlock.label} />
            {:else}
                <svg role="img" class="mt-icon">
                    <use xlink:href={mtappVars.static_path + '/images/sprite.svg#ic_file'} />
                </svg>
            {/if}
            {getFilename(storage[storageKey].url)}
        </a>
    {/if}

    <div class="btn-group" role="group">
        <button type="button" class="btn btn-default" on:click|preventDefault={select}>{assetAddButtonLabel}</button>
        {#if storage[storageKey].url}
            <button type="button" on:click|preventDefault={remove} class="btn btn-default p-1 assetField-remove-image" aria-label="Remove">
                <svg role="img" class="mt-icon">
                    <use xlink:href={mtappVars.static_path + '/images/sprite.svg#ic_trash'} />
                </svg>
            </button>
        {/if}
    </div>

    {#if storage[storageKey].required && isEmpty(storage[storageKey])}
        <span class="text-danger fw-bold">{mtappVars.translate['This field is required']}</span>
    {/if}

    {#if typeof fieldBlock.textFieldLabel !== 'undefined' && fieldBlock.textFieldLabel}
        <div class="mt-3 mb-0">
            <label for={id + '-alt'}>{fieldBlock.textFieldLabel}</label>
            <input id={id + '-alt'} class="form-control" type="text" bind:value={storage[storageKey].alt} on:blur={triggerInputChange} />
        </div>
    {/if}
</div>
